<div class="column content-container">
	<div class="content-container-header">
		<h3 i18n="@@roleDetailConfirmation-confirmationHeader"><b>Confirmation</b></h3>
		<mat-divider></mat-divider>

		<div class="content-container-body">
			@if (showLoading) {
				<div>
					<mat-spinner diameter="35" style="float: left"></mat-spinner>
					<h3 style="float: left; margin-top: 7px; margin-left: 1em" i18n="@@roleDetailConfirmation-loadingMessage">
						Loading...
					</h3>
				</div>
			}

			@if (showSuccess) {
				<div data-automation-id="role-detail-confirmation-success-message">
					<span class="emphasized"
						>{{ users.length }}
						<ng-container [ngPlural]="users.length">
							<ng-template i18n="@@roleDetailConfirmation-userSingular" ngPluralCase="=1">user</ng-template>
							<ng-template i18n="@@roleDetailConfirmation-userPlural" ngPluralCase="other">users</ng-template>
						</ng-container>
					</span>
					<ng-container>&nbsp;</ng-container>
					<ng-container [ngPlural]="users.length">
						<ng-template i18n="@@roleDetailConfirmation-wasAssignedTo" ngPluralCase="=1">was assigned to</ng-template>
						<ng-template i18n="@@roleDetailConfirmation-wereAssignedTo" ngPluralCase="other"
							>were assigned to</ng-template
						>
					</ng-container>
					<ng-container>&nbsp;</ng-container>
					<span class="emphasized">{{ roleName }}</span
					>.<br />
					<br />
					<ng-container i18n="@@roleDetailConfirmation-verificationEmailsSent"
						>Verification emails have been sent to the following:</ng-container
					><br />
					@for (user of users; track user) {
						<div>
							<span class="emphasized">{{ user.email }}</span>
						</div>
					}
				</div>
			}

			@if (showFailure) {
				<div data-automation-id="role-detail-confirmation-error-message">
					<h3>
						<ng-container i18n="@@roleDetailConfirmation-errorWhenAssigningUsersTo"
							>Error when assigning user(s) to</ng-container
						>
						<ng-container>&nbsp;</ng-container>
						<span class="emphasized">{{ roleName }}</span
						>.
					</h3>
				</div>
			}

			<div style="margin-top: 24px; margin-bottom: 24px">
				<mat-divider></mat-divider>
			</div>

			<div style="position: sticky; float: left; margin-top: 8px">
				<button
					mat-button
					class="primary-button"
					(click)="returnToRoles()"
					i18n="@@roleDetailConfirmation-returnToRoles"
					data-automation-id="return-to-roles-button"
				>
					Return to Roles
				</button>
			</div>
		</div>
	</div>
</div>
